/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';

import BgImage1 from '../assets/images/course1.png';
import BgImage3 from '../assets/images/course3.png';
import BgImage2 from '../assets/images/course2.png';
import profile from '../assets/svgs/profile.svg';
import ProgrammesGrid from '../components/layouts/ProgrammesGrid';
import { useAppSelector } from '../store';

function Programmes() {
  const { loggedIn, user } = useAppSelector((state) => state?.auth);
  const navigate = useNavigate();

  useEffect(() => {
    if (!loggedIn) {
      navigate('/sign-in');
    }

    window.scrollTo(0, 0);
    document.title = 'Purple Academy - Programmes';
  }, [loggedIn]);

  return (
    <div className="relative pt-10 pb-20 bg-white">
      <div className="content">
        <img
          src={BgImage1}
          alt=""
          className="hidden lg:block w-32 h-auto right-20 absolute"
        />
        <div className="flex flex-col gap-y-2">
          <div
            aria-label="profile picture"
            className="h-[231px] w-[231px] rounded-full border"
          >
            <img src={profile} alt="profile" />
          </div>
          <p>{user?.fullName}</p>
          <p>Staff ID: {user?.staffId}</p>
        </div>

        <div className="mt-6 pb-10">
          <h1 className="font-title font-semibold">
            Welcome to your training dashboard, click on your preferred category
            and let’s fuel your success story
          </h1>

          <ProgrammesGrid />
        </div>
        <div className="">
          <img
            src={BgImage3}
            alt=""
            className="hidden lg:block w-32 h-32 absolute left-16 -mt-[350px] object-contain"
          />
        </div>
        <div className="">
          <img
            src={BgImage2}
            alt=""
            className="hidden lg:block w-32 h-32 absolute right-20 -mt-[280px] object-contain"
          />
        </div>
      </div>
    </div>
  );
}

export default Programmes;
